/**
 * F3.UX-3: Shared table loading skeleton. Replaces 20+ duplicated
 * animate-pulse blocks in admin/mod pages.
 */
interface TableSkeletonProps {
  rows?: number
  withSearch?: boolean
}

export default function TableSkeleton({ rows = 5, withSearch = true }: TableSkeletonProps) {
  return (
    <div className="space-y-3" role="status" aria-label="Yükleniyor">
      {withSearch && <div className="h-10 w-full max-w-sm bg-secondary rounded-lg animate-pulse" />}
      <div className="rounded-xl border border-border overflow-hidden">
        <div className="bg-secondary/50 h-10 animate-pulse" />
        <div className="divide-y divide-border">
          {Array.from({ length: rows }).map((_, i) => (
            <div key={i} className="h-16 flex items-center px-4 gap-3 animate-pulse">
              <div className="w-10 h-10 rounded-full bg-secondary flex-shrink-0" />
              <div className="flex-1 space-y-2">
                <div className="h-3 w-1/3 bg-secondary rounded" />
                <div className="h-2.5 w-1/2 bg-secondary rounded" />
              </div>
              <div className="h-8 w-20 bg-secondary rounded" />
            </div>
          ))}
        </div>
      </div>
      <span className="sr-only">Tablo yükleniyor</span>
    </div>
  );
}
